<template>
  <div style="padding: 10px; font-size: 12px;">
    Wait a moment...
  </div>
</template>
<script>
import user from '../services/user'
export default {
  created () {
    setTimeout(() => {
      let hash = {}

      window.location.hash.replace(/^#\/?/, '').split('&').forEach(function (kv) {
        let spl = kv.indexOf('=')
        if (spl !== -1) {
          hash[kv.substring(0, spl)] = decodeURIComponent(kv.substring(spl + 1))
        }
      })

      let url = 'https://network.indiefy.net/spotify-auth'
      let apiUrl = 'https://indiefy.net/v1/'

      if (location.href.match(/localhost/)) {
        url = `${location.protocol}//${location.host}/spotify-auth`
        apiUrl = 'https://localhost:3000/v1/'
      }

      var userId = ''

      if (this.$user) {
        userId = this.$user._id
      }

      window.$.post(`${apiUrl}auth/authorize-spotify`, { userId: userId, redirect: url, code: location.href.split('code=')[1] }).then(response => {
        let hash = response

        if (hash.access_token) {
          localStorage.setItem('tokenDate', new Date().toISOString())
          localStorage.setItem('accessToken', hash.access_token)
          localStorage.setItem('spotifyToken', hash.access_token)
          localStorage.setItem('refreshToken', hash.refresh_token)

          location.href = '/campaigns'
        } else {
          alert('No Token Provided')
          location.href = '/campaigns'
        }
      }).catch(error => {
        localStorage.removeItem('accessToken')
        localStorage.removeItem('spotifyToken')
        window.location.href = 'https://network.indiefy.net/'
        console.log(error.response)
      })
    }, 100)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SpotifyAuth.vue